import {useState} from "react";
import IMG from "../../../constants/image";

const Pagination = ({totalItems = 100, itemsPerPage = 10, setPage}) => {
	const [currentPage, setCurrentPage] = useState(1);
	const totalPages = Math.ceil(totalItems / itemsPerPage);
	const generatePageNumbers = () => {
		const pageNumbers = [];
		const maxVisiblePages = 5;
		const halfVisible = Math.floor(maxVisiblePages / 2);
		
		let startPage = Math.max(currentPage - halfVisible, 1);
		let endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
		
		if (endPage - startPage + 1 < maxVisiblePages) {
			startPage = Math.max(endPage - maxVisiblePages + 1, 1);
		}
		
		for (let i = startPage; i <= endPage; i++) {
			pageNumbers.push(i);
		}
		
		return pageNumbers;
	};
	
	const handlePageChange = (page) => {
		if (page >= 1 && page <= totalPages) {
			setCurrentPage(page);
			setPage && setPage(page);
		}
	};
	
	return (
		<nav
			className="flex items-center justify-center space-x-2 p-4 text-sm"
			role="navigation"
			aria-label="Pagination Navigation"
		>
			<p>Trang</p>
			{totalPages > 1 &&
				<button
					onClick={() => handlePageChange(currentPage - 1)}
					disabled={currentPage === 1}
					aria-label="Previous page"
				>
					<img className='transform rotate-180' src={IMG.icon.arrowTriangleRight} alt="arrowTriangleRight"/>
				</button>}
			
			<div className="flex space-x-2">
				{generatePageNumbers().map((page) => (
					<button
						key={page}
						onClick={() => handlePageChange(page)}
						className={`px-4 py-2 rounded-lg transition-all duration-200 ${page === currentPage ? "bg-[#F8C518] text-white" : "bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"}`}
						aria-label={`Page ${page}`}
						aria-current={page === currentPage ? "page" : undefined}
					>
						{page}
					</button>
				))}
			</div>
			{totalPages > 1 &&
				<button
					onClick={() => handlePageChange(currentPage + 1)}
					disabled={currentPage === totalPages}
					aria-label="Next page"
				>
					<img src={IMG.icon.arrowTriangleRight} alt="arrowTriangleRight"/>
				</button>
			}
		</nav>
	);
};

export default Pagination;